/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/connections-api';
}

/**
 * Parameters for `ConnectionsApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
